module.exports = __webpack_public_path__ + "static/desktop/img/calendar-5-thumb.73da4570.png";